import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './app/App';
import { attachRequestSecurity } from './app/store/hmacUtils';
import 'atropos/css'

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (apiBaseUrl && String(url).startsWith(apiBaseUrl)) {
    return attachRequestSecurity(config);
  }
  return config;
});

ReactDOM.render(

  <BrowserRouter>

     <App />

  </BrowserRouter >
  , document.getElementById('root'));







